import { render, staticRenderFns } from "./AILogic.vue?vue&type=template&id=9f4aff94&scoped=true"
import script from "./AILogic.vue?vue&type=script&lang=js"
export * from "./AILogic.vue?vue&type=script&lang=js"
import style0 from "./AILogic.vue?vue&type=style&index=0&id=9f4aff94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4aff94",
  null
  
)

export default component.exports